import { z } from "zod";
import { UploadIdCardInputSchema } from "./UploadIdCardInput";

const LINK_TOKEN_HASH_MAX_LENGTH = 256;

export const UploadIdCardPublicInputSchema = UploadIdCardInputSchema.extend({
    linkTokenHash: z.string().min(1).max(LINK_TOKEN_HASH_MAX_LENGTH),
});

export type UploadIdCardPublicInput = z.infer<typeof UploadIdCardPublicInputSchema>;
